var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessibleIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 458.54 461.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m224.83,371.01c-11.35-1.05-22.71-2.01-34.01-3.58-7.31-1.02-14.73-1.15-22.08-1.89-7.31-.73-14.57-2.12-21.89-2.48-7.25-.36-14.56-.83-21.59-2.18-4.95-.95-7.22,1.62-8.87,4.39-3.58,6.01-8.55,10.88-12.46,16.57-.22.32-.13.85-.18,1.29-.85.86-1.71.79-2.56,0-13.07-7.04-25.42-15.33-38.65-22.13-7.96-4.09-15.35-9.27-23.02-13.93-2.08-1.27-5.76-.85-6.04-3.88-.26-2.84,2.54-4.87,4.1-7.16,12.62-18.56,25.05-37.26,38.15-55.49,6.69-9.3,16.68-12.85,28.13-12.01,3-.67,6.02.97,9.02-.04,3.11-.41,6.17.67,9.28.37,1.81,0,3.63,0,5.44,0,1.79.12,3.62-.28,5.39.28,4.13.02,8.26.03,12.39.05.26.02.52.04.78.06,5.49.08,10.99.02,16.48.04,8.99-.07,17.95.78,26.94.45,10.63,0,21.26-.02,31.89.03,1.4,0,2.92-.5,4.21.53,6.56,1.95,10.11,6.92,11.35,13.07,1.2,5.95-.32,11.6-5.85,15.38-.45.31-.72.89-1.07,1.34-.49.71-.69,1.36.35,1.78,6.28.38,12.54.73,18.83.56,8.37.19,16.74-.38,25.09.29,9.1,1.58,16.71-3.01,24.64-6.08,14.93-5.77,29.79-11.73,44.67-17.65,15.55-6.18,31.01-12.59,46.65-18.52,7.2-2.73,15.01-1.18,16.73,7.9.97,1.78.97,3.55,0,5.33-.53,5.64-4.57,8.2-9.01,10.61-10.5,5.7-21.22,10.96-31.43,17.22-3.67,2.25-7.85,3.92-11.72,6.02-10.82,5.87-21.69,11.65-32.5,17.55-15.15,8.28-30.24,16.67-45.39,24.97-10.25,5.61-20.46,11.31-30.86,16.63-4.4,2.25-8.99,4.48-14.22,4.28-2.37.49-4.75.47-7.12.01Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.35,228.53c-.03-13.66-.14-27.32-.07-40.98.04-7.9,8.12-17.64,16.1-19.8,1.39-.38,2.79-.72,4.18-1.08,5.89-.5,11.79-.47,17.69-.01,7.44,1.54,13.3,5.3,17.49,11.8,2.55,3.95,3.53,8.32,3.61,12.74.24,12.44.03,24.9,0,37.35-.72.7-1.64.52-2.5.52-18.01,0-36.02,0-54.02,0-.86,0-1.78.18-2.5-.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.36,187.04c11.55.46,20.84,9.75,22.1,22.09.52,13.29.54,26.59,0,39.88-6.55.81-13.13.33-19.7.33-12.88,0-25.76.28-38.63-.15-1.06-1.94-.46-4.03-.5-6.05-.25-11.31.36-22.64-.34-33.95-.18-11.52,10.72-22.06,21.85-22.15,5.08-.59,10.15-.59,15.23,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.06,187.04c9.41-.01,20.37,8.09,22.1,21.21.52,13.59.53,27.18,0,40.76-2.14.76-4.35.35-6.53.34-17.28-.08-34.55.29-51.82-.18-1.1-4.44-.35-8.96-.48-13.44-.28-9.75.39-19.52-.35-29.26,1.59-5.12,3.37-10.08,7.79-13.65,3.91-3.16,8.1-5.46,13.21-5.76,5.36-.63,10.72-.57,16.08-.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.04,124.33c19.42.74,31.93,21.71,24.07,40.07-4.85,11.32-13.73,17.4-25.48,18.11-15.39.93-28.24-10.73-30.36-25.48-2.31-16.08,8.62-30.4,23.89-32.64,1.13-.17,2.24-.49,3.36-.74,1.42.77,3.1-.16,4.51.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.96,103.94c6.76,1.57,12.9,4.12,17.78,9.43,7.69,8.36,9.98,21.89,4.44,32.67-4.88,9.49-12.59,14.8-23.1,16.19-1.77-.5-3.54-.5-5.31,0-13.34.25-26.25-14.61-26.63-26.34-.36-11.34,3-20.43,12.47-27.07,4.05-2.84,8.61-3.9,13.27-4.88,2.36-.48,4.72-.48,7.08,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.28,155.38c-2.89,17.49-13.29,26.02-28.52,27.19-13.44,1.03-27.44-11.06-29.14-23.83-.07-.55-.44-1.06-.67-1.59.94-2.63-.23-5.44.67-8.07-.29-9.3,9.37-21.35,19.06-23.73,2.5-.62,5.03-1.13,7.55-1.69,1.42.77,3.1-.16,4.51.68,12.04.26,25.19,10.18,26.53,26.5.48,1.52.48,3.03,0,4.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.84,248.86c19.36,0,38.73,0,58.09,0,.3-.33.6-.34.89,0-.91,1.4-2.35.95-3.6.95-17.56.02-35.12.02-52.68,0-1.25,0-2.69.44-3.6-.95.29-.34.59-.36.89,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.08,248.82c19.38.01,38.76.03,58.15.04.3-.34.6-.33.89,0-.91,1.4-2.35.95-3.6.95-17.57.02-35.14.02-52.71,0-1.25,0-2.69.46-3.58-.98.28-.33.56-.33.86-.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.35,228.53c19.67,0,39.34,0,59.02,0-.7,1.4-2.01.97-3.11.97-17.6.03-35.2.03-52.8,0-1.1,0-2.41.43-3.11-.97Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.84,248.86c-.3,0-.6,0-.89,0,0-14.13.01-28.26.02-42.39,1.33,1.36.72,3.06.73,4.6.09,12.59.11,25.19.14,37.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.82,248.87c-.3,0-.6,0-.89,0,.08-13.54.15-27.07.23-40.61.92.77.77,1.84.77,2.85-.03,12.59-.07,25.18-.1,37.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.08,248.82l-.43.06s-.43-.04-.43-.04c.02-13.22.03-26.43.05-39.65,1.25,1.38.71,3.06.72,4.61.06,11.67.06,23.35.09,35.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.13,248.87c-.3,0-.6,0-.89,0,.08-13.24.15-26.48.23-39.73.92.77.77,1.84.77,2.85-.03,12.3-.07,24.59-.1,36.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.67,270.29c-12.03-.09-24.06-.18-36.1-.26-.29-.08-.41-.21-.36-.37.06-.18.13-.27.21-.27,11.03-.04,22.06-.08,33.1-.1,1.13,0,2.41-.3,3.14,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.43,269.38c.05.21.1.43.14.64-9.13.02-18.26.03-27.39.05-.09-.23-.18-.46-.27-.69.35-.39.79-.57,1.32-.53,3.46.16,6.93-.37,10.37.3,5.27.08,10.55.15,15.82.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.37,302.71c-8.53,0-17.05,0-25.58,0-.3-.08-.43-.21-.37-.37.06-.19.14-.28.22-.28,7.62-.02,15.24-.05,22.86-.06,1.01,0,2.07-.14,2.88.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.64,302.05c.06.22.11.43.15.65-6.35.05-12.71.1-19.06.13-.8,0-1.79.24-2.1-.95,3.2-.79,6.4-.41,9.6-.03,3.8.06,7.6.13,11.4.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.26,166.65c-5.9,0-11.79,0-17.69.01,5.89-1.23,11.79-1.21,17.69-.01Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.06,187.04c-5.36,0-10.72.01-16.08.02,5.36-1.37,10.72-1.35,16.08-.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.36,187.04c-5.08,0-10.15,0-15.23,0,5.08-1.32,10.15-1.32,15.23,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.61,269.15c-3.85-.03-7.7-.05-11.55-.08-.23-.17-.3-.33-.2-.47.09-.13.18-.19.28-.19,3.82.38,7.74-.92,11.48.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.24,301.85c-3.2,0-6.4.02-9.6.03.29-1.33,1.23-1.77,2.47-1.8,1.95,2.29,5.1-.18,7.13,1.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.07,273.71c0-1.78,0-3.55,0-5.33,2.47,1.77,2.48,3.55,0,5.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.4,269.16c-3.23,0-6.46,0-9.68,0-.38-.47-.3-.84.23-1.12,1.67-.02,3.35-.36,4.98.24,1.44.09,2.87.17,4.31.26.32.07.45.18.39.34-.07.19-.14.28-.23.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.56,268.51c.05.22.1.43.16.65-2.96-.14-6.01.86-8.88-.64l-.1-.33c1.79-.34,3.57-.43,5.35.06h2.65c.39-.27.66-.2.81.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.13,268.41c-.02.22-.04.44-.07.66,0,0,.07.37.07.37-2.81.53-5.63.2-8.45.19-.56-.27-.7-.67-.41-1.22,2.96,0,5.91,0,8.87,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.27,268.41c.01.24.02.48.03.72-2.64,1.12-5.34.57-8.03.3l.1-.24c2.5-1.59,5.27-.45,7.9-.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.62,149.07c-.16,2.7.86,5.49-.67,8.07.13-2.7-.86-5.49.67-8.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.96,103.94c-2.36,0-4.72,0-7.08,0,2.36-1.2,4.72-1.2,7.08,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.83,371.01c2.37,0,4.75,0,7.12-.01-2.37,1.17-4.75,1.19-7.12.01Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.56,268.51c-.28-.08-.55-.17-.81-.27,2.07-1.12,4.13-1.15,6.18.03-1.79.08-3.58.16-5.37.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.97,269.13c-1.77,0-3.54,0-5.31,0-.29-.13-.4-.26-.31-.41.09-.16.18-.23.27-.23,1.8.11,3.7-.71,5.35.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.62,268.48c.02.22.03.43.04.65-1.75,0-3.51.02-5.26.03-.06-.21-.11-.42-.16-.63,1.79-.02,3.59-.04,5.38-.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.1,268.25c-1.78-.02-3.57-.04-5.35-.06,1.79-1.03,3.58-1.11,5.35.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.76,162.24c1.77-1.13,3.54-1.13,5.31,0-1.77,0-3.54,0-5.31,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.74,124.33c-1.52-.1-3.17.58-4.51-.68,1.54,0,3.19-.73,4.51.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.04,124.33c-1.52-.1-3.17.58-4.51-.68,1.54,0,3.19-.73,4.51.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.28,155.38c0-1.52,0-3.03,0-4.55,1.16,1.52,1.16,3.03,0,4.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.18,383.13c.85,0,1.71,0,2.56,0-.09.65.02,1.5-.92,1.54-.96.03-1.35-.75-1.65-1.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.1,302.28h-64.56c0-.22-.01-.44-.02-.66h64.61c-.01.22-.02.44-.03.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.27,269.42c2.68-.1,5.35-.2,8.03-.3,2.94.11,5.89.21,8.83.32-.01.21,0,.43.06.64-5.64-.24-11.33.92-16.92-.65Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibleIconWhite);
export default __webpack_public_path__ + "static/media/accessible_icon_white.410b7e328048a9a5e936045c42c3126e.svg";
export { ForwardRef as ReactComponent };